export default __webpack_public_path__ + "static/media/icon-benchToAboveShoulder.b31d2adf.svg";